/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import {
  Button,
  Grid,
  Header,
  Icon,
  Label,
  Segment,
} from 'semantic-ui-react';
import { SortableElement, arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableDragHandle } from '../';
import PackagePricingItemEdit from './PackagePricingItemEdit';
import { flashErrorMessage } from '../../../actions/flash';
import AppForm from '../../../components/AppForm';
import DeleteConfirm from '../../../containers/modals/DeleteConfirm';
import { PROJECT_PACKAGE_PRICING_ITEM_DEFAULT } from '../../../structs/package_pricing';

const SortableItem = SortableElement(props => (
  <div className={`sortablehoc_item ${props.itemClass ? props.itemClass : ''}`}>
    <Segment className={`item ${props.isEditing() ? 'editing' : ''}`}>
      <Grid>
        <Grid.Row className="row_item">
          <Grid.Column mobile={2} tablet={2} computer={1} verticalAlign="middle">
            {
                props.isSortMode ?
                  (
                    <div className="sorting_buttons">
                      <SortableDragHandle {...props} />
                    </div>
                  ) : (
                    <div>
                      <Label basic={props.value.isEnabled} color={props.value.isEnabled ? null : 'red'} circular>{props.value.orderPriority}</Label>
                    </div>
                  )
              }
          </Grid.Column>
          <Grid.Column mobile={10} tablet={11} computer={13} verticalAlign="middle">
            {props.isEditing() ? '' : (
              <span>
                <span className="text_name">{props.value.name}{props.value.description !== '' ? ':' : ''}</span> <span className="text_description">{props.isEditing() ? '' : props.value.description}</span>
              </span>
            )}
          </Grid.Column>
          <Grid.Column mobile={4} tablet={3} computer={2} textAlign="right">
            <Button
              size="tiny"
              color="blue"
              compact
              disabled={props.isSortMode}
              onClick={e => props.handleEdit(e, props.idx)}
            >
              <Icon name="edit" />
              {props.isEditing() ? 'Done' : 'Edit'}
            </Button>
          </Grid.Column>
        </Grid.Row>
        {
            props.isEditing() ?
              <Grid.Row>
                <Grid.Column width={16}>
                  <PackagePricingItemEdit
                    data={props.value}
                    onChange={props.onChange}
                    onDelete={props.onDelete}
                    refForm={props.setRefForm}
                    refValidation={props.setRefValidation}
                  />
                </Grid.Column>
              </Grid.Row>
              : ''
          }
      </Grid>
    </Segment>
  </div>
));


export default class SortablePackagePricingItem extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.array]).isRequired,
    onChange: PropTypes.func,
    onDeleteItem: PropTypes.func,
    onEditingItems: PropTypes.func,
    onSortItems: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const data = props.data || [];
    return {
      data,
    };
  }
  constructor(props) {
    super(props);
    const state = SortablePackagePricingItem.getPropsToState(props);
    this.state = {
      ...state,
      isEditing: [],
      isSortMode: false,
      showDeleteItemConfirm: false,
      deleteItemIDX: null,
      deleteItemData: Object.assign({}, PROJECT_PACKAGE_PRICING_ITEM_DEFAULT),
    };
    this.editRef = [];
    this.formRef = {};
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const data = this.sortDataByIndex(arrayMove(this.state.data, oldIndex, newIndex));
    this.setState({ data }, () => {
      if (this.props.onChange) this.props.onChange(data);
    });
  };
  setRefValidation = (ref, idx) => {
    if (ref && ref.props && ref.props.name) {
      if (!this.editRef[idx]) this.editRef[idx] = {};
      this.editRef[idx][ref.props.name] = ref;
    }
  }
  setRefForm = (ref) => {
    this.formRef = ref;
  }
  checkIsEditiing = id => this.state.isEditing.includes(id);
  sortDataByIndex = (newData) => {
    const data = newData;
    data.forEach((d, index) => {
      data[index].orderPriority = index + 1;
    });
    return data;
  }
  handleEdit = async (e, idx) => {
    if (e) e.preventDefault();
    const { data, isEditing } = this.state;
    if (this.state.isEditing.includes(idx)) {
      const { store } = this.context;
      const validations = await AppForm.validate(this.editRef[idx], data[idx]);
      const errMessages = validations.filter(v => !v.isValid);
      if (errMessages.length > 0) {
        store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errMessages.map(l => l.message) }));
        return;
      }
      this.setState({ isEditing: isEditing.filter(ai => ai !== idx) }, () => {
        if (this.props.onEditingItems) this.props.onEditingItems(this.state.isEditing, data);
      });
      return;
    }
    isEditing.push(idx);
    this.setState({ isEditing }, () => {
      if (this.props.onEditingItems) this.props.onEditingItems(this.state.isEditing, data);
    });
  }
  handleToggleSort = (e) => {
    e.preventDefault();
    this.setState({ isSortMode: !this.state.isSortMode }, () => {
      if (this.props.onSortItems) this.props.onSortItems(!this.state.isSortMode);
    });
  }
  handleChangeItem = (d, idx) => {
    const { data } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    this.setState({ data: newData }, () => {
      if (this.editRef[idx]) AppForm.validate(this.editRef[idx], newData[idx]);
      if (this.props.onChange) this.props.onChange(newData);
    });
  }
  handleDeleteItem = (d, idx) => {
    this.setState({
      showDeleteItemConfirm: true,
      deleteItemIDX: idx,
      deleteItemData: d,
    });
  }
  handleCancelDeleteItem = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteItemConfirm: false,
      deleteItemIDX: null,
      deleteItemData: Object.assign({}, PROJECT_PACKAGE_PRICING_ITEM_DEFAULT),
    });
  }
  handleConfirmDeleteItem = (e) => {
    e.preventDefault();
    const { deleteItemData } = this.state;
    if (this.props.onDeleteItem) {
      this.props.onDeleteItem(deleteItemData.id, () => {
        this.confirmDeleteItem();
      });
    }
  }
  confirmDeleteItem = () => {
    const { data, deleteItemIDX } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i !== deleteItemIDX) {
        newData.push(item);
      }
    });
    this.setState({
      data: this.sortDataByIndex(newData),
      showDeleteItemConfirm: false,
      deleteItemIDX: null,
      deleteItemData: Object.assign({}, PROJECT_PACKAGE_PRICING_ITEM_DEFAULT),
    }, () => this.handleEdit(null, deleteItemIDX));
  }
  handleAddItem = (e) => {
    e.preventDefault();
    const { isEditing, data } = this.state;
    isEditing.push(data.length);
    const newItem = clone(Object.assign({}, PROJECT_PACKAGE_PRICING_ITEM_DEFAULT, {
      orderPriority: data.length + 1,
    }));
    data.push(newItem);
    this.setState({ isEditing, data }, () => {
      if (this.props.onEditingItems) this.props.onEditingItems(isEditing, data);
    });
  }
  render() {
    const {
      data,
      deleteItemData,
      isEditing,
      isSortMode,
      showDeleteItemConfirm,
    } = this.state;
    return (
      <Segment basic className="project_package_pricing_item">
        <DeleteConfirm
          content={`Are you sure you want to delete fomula ${deleteItemData.orderPriority}?`}
          onClose={this.handleCancelDeleteItem}
          onConfirm={this.handleConfirmDeleteItem}
          open={showDeleteItemConfirm}
        />
        <Grid>
          <Grid.Row verticalAlign="middle">
            <Grid.Column width={8} textAlign="left">
              <Header as="h4" className="header_title">
                Formula(s)
              </Header>
            </Grid.Column>
            <Grid.Column width={8} textAlign="right">
              <Button disabled={isEditing.length > 0 || data.length < 1} basic={!isSortMode} active={isSortMode} color={isSortMode ? 'blue' : null} compact onClick={this.handleToggleSort}>
                <Icon name={isSortMode ? 'toggle on' : 'toggle off'} color={isSortMode ? null : 'blue'} />
                Sort Formula
              </Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="row_content">
            <Grid.Column width={16}>
              {data.length > 0 ? (
                <SortableContainer
                  isSortMode={isSortMode}
                  iconColor="blue"
                  helperClass="sorting"
                  data={data}
                  lockAxis="y"
                  lockToContainerEdges
                  onSortEnd={this.onSortEnd}
                  useDragHandle
                  item={props => (
                    <SortableItem
                      {...props}
                      handleEdit={this.handleEdit}
                      isEditing={() => this.checkIsEditiing(props.idx)}
                      onChange={d => this.handleChangeItem(d, props.idx)}
                      onDelete={d => this.handleDeleteItem(d, props.idx)}
                      setRefForm={this.setRefForm}
                      setRefValidation={ref => this.setRefValidation(ref, props.idx)}
                    />
                  )}
                />
              ) : (
                <Segment className="segment_formula_not_found" textAlign="center">No formula(s) found</Segment>
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row textAlign="center" className="row_button_add">
            <Grid.Column width={16}>
              <Button
                basic
                onClick={this.handleAddItem}
              >
                <Icon name="add circle" color="green" /> Add formula
            </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/SortablePackagePricingItem.jsx